/* ============================================================================
FILE: po-katupirsia5-tiqqunbahu-texts-fr-en-es-20260303.js
MODE: JS FR/EN/ES (injection tri) + lexicon override (termes FR) si présent
API:  window.PoKatupirsia5TiqqunbahuTextsFR_EN_ES_20260303

ROLE:
  - Injecte le contenu FR/EN/ES dans les slots selon la langue choisie (localStorage).
  - Lang storage:
      - clé principale : po_lex_lang
      - clé compat :     goody_gp_lang
    Langues autorisées : fr, en, es.
  - Expose getLang(), setLang(lang), init() et stopAudio() ; déclenche po:locale-changed après bascule.
  - Écoute po:lexicon-ready pour re-render si le lexique arrive après.
  - Protection fine PRIORITAIRE : verrouille (translate="no") TOUTES les occurrences du lexique simplifié
    FR canonique via meta.lexique_simplifie_fr (si dispo), variantes apostrophes + œ/oe,
    + anti-collage (espaces DOM uniquement quand nécessaire).
  - Ajout slot CTA fin de page : data-po-slot="cta_translate" (texte tri, sans toucher au href).
  - Ajoute une couche audio générale + audio locale par bloc, sans casser le socle existant.
============================================================================ */

(function(){
  "use strict";

  if (window.__PO_K5_TIQQUNBAHU_TEXTS_20260303__) return;
  window.__PO_K5_TIQQUNBAHU_TEXTS_20260303__ = true;

  var STORAGE_KEY = "po_lex_lang";
  var STORAGE_KEY_COMPAT = "goody_gp_lang";

  // IMPORTANT: on cible UNIQUEMENT cette page
  var AXIS_LEX_ID = "tiqqunbahu";
  var ROOT_SEL =
    '.po-axis-section[data-po-axis][data-po-lex-id="' + AXIS_LEX_ID + '"], ' +
    '.po-axis-section[data-po-axis="' + AXIS_LEX_ID + '"], ' +
    '.po-axis-section[data-po-lex-id="' + AXIS_LEX_ID + '"]';

  var CANON = {
    title: "Tiqqunbahu",
    page_terms: [
      "Tiqqunbahu",
      "Tiqqun",
      "Bahu",
      "Katûpirsia",
      "Katûpirsia 5",
      "La Matrice-substrat",
      "Katûsýs",
      "Katûvýs",
      "Katûvýsqun",
      "Êkhö",
      "Taxiêlîs",
      "Takimarah",
      "Lulæṣírasen",
      "Balakallpa",
      "Posœnnoïa",
      "co-présence synchrêtique",
      "nombre-guide"
    ]
  };

  function clampStr(v){ return (v == null) ? "" : String(v); }

  function normLang(raw){
    var s = clampStr(raw).toLowerCase().trim().replace(/_/g, "-");
    if (s === "fr" || s.indexOf("fr") === 0) return "fr";
    if (s === "en" || s.indexOf("en") === 0) return "en";
    if (s === "es" || s.indexOf("es") === 0) return "es";
    return "fr";
  }

  function readStoredLang(){
    var v = "";
    try{ v = localStorage.getItem(STORAGE_KEY) || ""; }catch(e){ v = ""; }
    if (!v){
      try{ v = localStorage.getItem(STORAGE_KEY_COMPAT) || ""; }catch(_e){ v = ""; }
    }
    return v ? normLang(v) : "";
  }

  function storeLang(lang){
    var l = normLang(lang);
    try{ localStorage.setItem(STORAGE_KEY, l); }catch(e){}
    try{ localStorage.setItem(STORAGE_KEY_COMPAT, l); }catch(_e){}
    try{
      if (document && document.documentElement){
        document.documentElement.setAttribute("lang", l);
      }
    }catch(__e){}
    return l;
  }

  function getLang(){
    var s = readStoredLang();
    if (s) return s;
    var dl = (document && document.documentElement) ? (document.documentElement.getAttribute("lang") || "") : "";
    if (dl) return normLang(dl);
    return "fr";
  }

  function notifyLocaleChanged(){
    try{
      window.dispatchEvent(new Event("po:locale-changed"));
    }catch(e){
      try{
        var ev = document.createEvent("Event");
        ev.initEvent("po:locale-changed", true, true);
        window.dispatchEvent(ev);
      }catch(_e){}
    }
  }

  /* --------------------------------------------------------------------------
   * LEXIQUE RUNTIME (lecture)
   * -------------------------------------------------------------------------- */

  function getLexiconEntry(id){
    try{
      if (window.PO_LEXICON_MAP && window.PO_LEXICON_MAP[id]) return window.PO_LEXICON_MAP[id];
    }catch(e){}

    try{
      var arr = window.PO_LEXICON;
      if (Array.isArray(arr)){
        for (var i=0;i<arr.length;i++){
          if (arr[i] && arr[i].id === id) return arr[i];
        }
      }
    }catch(e){}
    return null;
  }

  function pickTerm(entry, lang){
    if (!entry) return "";
    try{
      if (entry.terms && entry.terms[lang]) return clampStr(entry.terms[lang]);
    }catch(e){}
    return "";
  }

  function pickDefShort(entry, lang){
    if (!entry) return "";
    var ks = "definition_short_" + lang;
    var k  = "definition_" + lang;
    try{
      if (entry[ks]) return clampStr(entry[ks]);
      if (entry[k])  return clampStr(entry[k]);
      if (entry.defs && entry.defs[lang] && entry.defs[lang].short) return clampStr(entry.defs[lang].short);
    }catch(e){}
    return "";
  }

  function pickDefLong(entry, lang){
    if (!entry) return "";
    var kl = "definition_long_" + lang;
    var k  = "definition_" + lang;
    try{
      if (entry[kl]) return clampStr(entry[kl]);
      if (entry[k])  return clampStr(entry[k]);
      if (entry.defs && entry.defs[lang] && entry.defs[lang].long) return clampStr(entry.defs[lang].long);
    }catch(e){}
    return "";
  }

  function pickArray(entry, lang, base){
    if (!entry) return [];
    var k = base + "_" + lang;
    try{
      var v = entry[k];
      if (Array.isArray(v)) return v;
    }catch(e){}
    return [];
  }

  function pickAny(entry, key, fallback){
    try{
      if (entry && entry[key] != null) return entry[key];
    }catch(e){}
    return fallback;
  }

  /* --------------------------------------------------------------------------
   * PROTECTION fine (occurrence par occurrence, DOM-safe) + anti-collage
   * - Base canonique: meta.lexique_simplifie_fr uniquement (si dispo)
   * -------------------------------------------------------------------------- */

  function escapeHTML(s){
    return clampStr(s)
      .replace(/&/g,"&amp;")
      .replace(/</g,"&lt;")
      .replace(/>/g,"&gt;")
      .replace(/\"/g,"&quot;")
      .replace(/'/g,"&#39;");
  }

  function escapeRegExp(s){
    return String(s).replace(/[.*+?^${}()|[\]\\]/g, "\\$&");
  }

  function uniqPush(arr, v, seen){
    var k = String(v || "");
    if (!k) return;
    if (seen[k]) return;
    seen[k] = true;
    arr.push(k);
  }

  function buildVariants(term){
    var out = [];
    var seen = Object.create(null);
    var t = clampStr(term);
    if (!t) return out;

    uniqPush(out, t, seen);
    uniqPush(out, t.replace(/’/g, "'"), seen);
    uniqPush(out, t.replace(/'/g, "’"), seen);
    uniqPush(out, t.replace(/œ/g, "oe").replace(/Œ/g, "OE"), seen);
    uniqPush(out, t.replace(/oe/g, "œ").replace(/OE/g, "Œ"), seen);

    var oe1 = t.replace(/œ/g, "oe").replace(/Œ/g, "OE");
    var oe2 = t.replace(/oe/g, "œ").replace(/OE/g, "Œ");
    uniqPush(out, oe1.replace(/’/g, "'"), seen);
    uniqPush(out, oe1.replace(/'/g, "’"), seen);
    uniqPush(out, oe2.replace(/’/g, "'"), seen);
    uniqPush(out, oe2.replace(/'/g, "’"), seen);

    return out;
  }

  function getSimplifiedLexiqueFRList(){
    var out = [];
    var seen = Object.create(null);

    function addMany(arr){
      if (!Array.isArray(arr)) return;
      for (var i=0;i<arr.length;i++) uniqPush(out, arr[i], seen);
    }

    try{
      if (window.PO_LEXICON_META && Array.isArray(window.PO_LEXICON_META.lexique_simplifie_fr)){
        addMany(window.PO_LEXICON_META.lexique_simplifie_fr);
      }
    }catch(e){}
    try{
      if (window.PO_LEXICON && window.PO_LEXICON.meta && Array.isArray(window.PO_LEXICON.meta.lexique_simplifie_fr)){
        addMany(window.PO_LEXICON.meta.lexique_simplifie_fr);
      }
    }catch(e){}

    addMany(CANON.page_terms);
    return out;
  }

  function buildProtectRegexFromSimplified(){
    var base = getSimplifiedLexiqueFRList();
    if (!base || !base.length) return null;

    var terms = [];
    var seen = Object.create(null);

    for (var i=0;i<base.length;i++){
      var vars = buildVariants(base[i]);
      for (var j=0;j<vars.length;j++) uniqPush(terms, vars[j], seen);
    }

    terms.sort(function(a,b){ return b.length - a.length; });

    var parts = [];
    for (var k=0;k<terms.length;k++) parts.push(escapeRegExp(terms[k]));
    if (!parts.length) return null;

    try{
      return new RegExp("(" + parts.join("|") + ")", "g");
    }catch(e){
      return null;
    }
  }

  var __PO_PROTECT_CACHE__ = { key:"", re:null };

  function ensureProtectEngineReady(){
    var key = "meta:none";
    try{
      var l = getSimplifiedLexiqueFRList();
      key = "meta:" + (l ? l.length : 0);
    }catch(e){
      key = "meta:none";
    }
    if (__PO_PROTECT_CACHE__.key === key) return;
    __PO_PROTECT_CACHE__.key = key;
    __PO_PROTECT_CACHE__.re = buildProtectRegexFromSimplified();
  }

  function isLockedElement(el){
    if (!el || el.nodeType !== 1) return false;
    var tr = el.getAttribute && el.getAttribute("translate");
    if (tr && String(tr).toLowerCase() === "no") return true;
    var cls = el.className || "";
    if (typeof cls === "string"){
      if (cls.indexOf("notranslate") !== -1) return true;
      if (cls.indexOf("po-lex-protect") !== -1) return true;
    }
    return false;
  }

  function isLockedNode(node){
    var el = (node && node.nodeType === 1) ? node : (node ? node.parentElement : null);
    while (el && el.nodeType === 1){
      if (isLockedElement(el)) return true;
      el = el.parentElement;
    }
    return false;
  }

  function isWordLikeChar(ch){
    return /[0-9A-Za-zÀ-ÖØ-öø-ÿ_]/.test(ch);
  }

  function protectTextNode(doc, textNode){
    ensureProtectEngineReady();
    var re = __PO_PROTECT_CACHE__.re;
    if (!re) return;

    var txt = textNode.nodeValue;
    if (!txt) return;

    re.lastIndex = 0;
    if (!re.test(txt)) return;

    re.lastIndex = 0;
    var frag = doc.createDocumentFragment();
    var last = 0;
    var m;

    while ((m = re.exec(txt)) !== null){
      var start = m.index;
      var match = m[0];
      var end = start + match.length;

      if (start > last){
        frag.appendChild(doc.createTextNode(txt.slice(last, start)));
      }

      var chPrev = (start - 1 >= 0) ? txt.charAt(start - 1) : "";
      if (chPrev && isWordLikeChar(chPrev)) frag.appendChild(doc.createTextNode(" "));

      var span = doc.createElement("span");
      span.setAttribute("translate", "no");
      span.className = "po-lex-protect notranslate";
      span.textContent = match;
      frag.appendChild(span);

      var chNext = (end < txt.length) ? txt.charAt(end) : "";
      if (chNext && isWordLikeChar(chNext)) frag.appendChild(doc.createTextNode(" "));

      last = end;
      if (match.length === 0) break;
    }

    if (last < txt.length) frag.appendChild(doc.createTextNode(txt.slice(last)));
    if (textNode.parentNode) textNode.parentNode.replaceChild(frag, textNode);
  }

  function protectKeywordsInElement(el){
    if (!el || !el.querySelectorAll) return;
    ensureProtectEngineReady();
    if (!__PO_PROTECT_CACHE__.re) return;

    var walker;
    try{
      walker = document.createTreeWalker(
        el,
        NodeFilter.SHOW_TEXT,
        {
          acceptNode: function(n){
            if (!n || !n.nodeValue) return NodeFilter.FILTER_REJECT;
            if (isLockedNode(n)) return NodeFilter.FILTER_REJECT;
            var p = n.parentNode;
            var pn = p && p.nodeName ? p.nodeName : "";
            if (pn === "SCRIPT" || pn === "STYLE") return NodeFilter.FILTER_REJECT;
            return NodeFilter.FILTER_ACCEPT;
          }
        },
        false
      );
    }catch(e){ return; }

    var nodes = [];
    var n;
    while ((n = walker.nextNode())) nodes.push(n);
    for (var i=0;i<nodes.length;i++) protectTextNode(document, nodes[i]);
  }

  function protectKeywordsHTML(html){
    if (!html) return "";
    ensureProtectEngineReady();
    if (!__PO_PROTECT_CACHE__.re) return String(html);

    var tpl = document.createElement("template");
    tpl.innerHTML = String(html);
    var root = tpl.content || tpl;

    var walker;
    try{
      walker = document.createTreeWalker(
        root,
        NodeFilter.SHOW_TEXT,
        {
          acceptNode: function(n){
            if (!n || !n.nodeValue) return NodeFilter.FILTER_REJECT;
            if (isLockedNode(n)) return NodeFilter.FILTER_REJECT;
            return NodeFilter.FILTER_ACCEPT;
          }
        },
        false
      );
    }catch(e){ return String(html); }

    var nodes = [];
    var t;
    while ((t = walker.nextNode())) nodes.push(t);
    for (var i=0;i<nodes.length;i++) protectTextNode(document, nodes[i]);
    return tpl.innerHTML;
  }

  function htmlParagraphize(txt){
    var s = clampStr(txt);
    if (!s) return "";
    return "<p>" + escapeHTML(s).replace(/\n+/g, "</p><p>") + "</p>";
  }

  function normalizeCanonicalFrench(text){
    var s = clampStr(text);
    if (!s) return s;

    s = s.replace(/\bsynchrêtic co-presence\b/gi, "co-présence synchrêtique");
    s = s.replace(/\bco-?presencia sincr[eé]tica\b/gi, "co-présence synchrêtique");
    s = s.replace(/\bcopresencia sincr[eé]tica\b/gi, "co-présence synchrêtique");
    s = s.replace(/\bguide-number\b/gi, "nombre-guide");
    s = s.replace(/\bn[uú]mero-gu[ií]a\b/gi, "nombre-guide");
    s = s.replace(/\bkat[uû]vysic field\b/gi, "champ de la Katûvýs");
    s = s.replace(/\bcampo kat[uû]v[ýy]sico\b/gi, "champ de la Katûvýs");
    return s;
  }

  /* --------------------------------------------------------------------------
   * AUDIO LOCAL PAR BLOC + TEXTE GÉNÉRAL
   * -------------------------------------------------------------------------- */

  var PO_AUDIO_SYNTH = (typeof window !== "undefined" && window.speechSynthesis) ? window.speechSynthesis : null;

  var PO_AUDIO_STATE = {
    root: null,
    units: [],
    unitPos: -1,
    chunks: [],
    chunkPos: -1,
    activeKey: "",
    speaking: false,
    utterance: null
  };

  var AUDIO_UI = {
    fr: { general: "Écouter le texte", block: "Écouter ce bloc", stop: "Arrêter la lecture" },
    en: { general: "Listen to the text", block: "Listen to this section", stop: "Stop playback" },
    es: { general: "Escuchar el texto", block: "Escuchar este bloque", stop: "Detener la lectura" }
  };

  function audioUI(lang){
    var L = normLang(lang);
    return AUDIO_UI[L] || AUDIO_UI.fr;
  }

  function ensureAudioStyles(){
    if (document.getElementById("po-axis-audio-styles-tiqqunbahu-20260303")) return;
    var st = document.createElement("style");
    st.id = "po-axis-audio-styles-tiqqunbahu-20260303";
    st.textContent = [
      ".po-axis-audio-wrap{display:flex;justify-content:center;margin:10px 0 12px;}",
      ".po-axis-audio-btn{display:inline-flex;align-items:center;justify-content:center;gap:8px;border:1px solid rgba(184,134,11,.45);border-radius:999px;padding:8px 12px;background:rgba(0,0,0,.02);font:inherit;font-weight:800;letter-spacing:.2px;cursor:pointer;user-select:none;-webkit-tap-highlight-color:transparent;box-shadow:0 0 0 1px rgba(184,134,11,.12),0 8px 18px rgba(31,122,58,.10);}",
      ".po-axis-audio-btn:hover{box-shadow:0 0 0 1px rgba(184,134,11,.24),0 10px 24px rgba(31,122,58,.14);}",
      ".po-axis-audio-btn.is-active{border-color:rgba(31,122,58,.55);box-shadow:0 0 0 1px rgba(31,122,58,.20),0 12px 28px rgba(31,122,58,.18);}",
      ".po-axis-audio-btn__label{color:var(--color-accent,#1f7a3a);}",
      ".po-lex-summary .po-axis-audio-btn{margin-left:auto;flex:0 0 auto;padding:6px 10px;font-size:12px;}",
      ".po-lex-summary .po-axis-audio-btn__label{white-space:nowrap;}",
      "@media (max-width:760px){.po-lex-summary{flex-wrap:wrap;}.po-lex-summary .po-axis-audio-btn{order:3;width:100%;justify-content:center;margin-top:8px;}}"
    ].join("");
    document.head.appendChild(st);
  }

  function createAudioButton(role, index){
    var btn = document.createElement("button");
    btn.type = "button";
    btn.className = "po-axis-audio-btn";
    btn.setAttribute("data-po-audio-role", role);
    if (index != null) btn.setAttribute("data-po-audio-index", String(index));
    btn.setAttribute("aria-pressed", "false");
    btn.innerHTML = '<span class="po-axis-audio-btn__label"></span>';
    return btn;
  }

  function getAudioButtonLabel(role, lang, isActive){
    var ui = audioUI(lang);
    if (isActive) return ui.stop;
    return role === "general" ? ui.general : ui.block;
  }

  function updateAudioButtonLabel(btn, lang, isActive){
    if (!btn) return;
    var role = clampStr(btn.getAttribute("data-po-audio-role") || "block");
    var label = btn.querySelector(".po-axis-audio-btn__label") || btn;
    label.textContent = getAudioButtonLabel(role, lang, !!isActive);
    btn.setAttribute("aria-pressed", isActive ? "true" : "false");
    if (isActive) btn.classList.add("is-active");
    else btn.classList.remove("is-active");
  }

  function updateAudioButtonsState(root, lang){
    if (!root) return;
    var btns = root.querySelectorAll(".po-axis-audio-btn[data-po-audio-role]");
    var activeKey = (PO_AUDIO_STATE.root === root) ? PO_AUDIO_STATE.activeKey : "";
    for (var i=0;i<btns.length;i++){
      var btn = btns[i];
      var role = clampStr(btn.getAttribute("data-po-audio-role") || "block");
      var idx = clampStr(btn.getAttribute("data-po-audio-index") || "");
      var key = (role === "general") ? "general" : ("block-" + idx);
      updateAudioButtonLabel(btn, lang, key && key === activeKey && PO_AUDIO_STATE.speaking);
    }
  }

  function stopAudio(resetButtons){
    try{
      if (PO_AUDIO_SYNTH) PO_AUDIO_SYNTH.cancel();
    }catch(e){}

    PO_AUDIO_STATE.root = null;
    PO_AUDIO_STATE.units = [];
    PO_AUDIO_STATE.unitPos = -1;
    PO_AUDIO_STATE.chunks = [];
    PO_AUDIO_STATE.chunkPos = -1;
    PO_AUDIO_STATE.activeKey = "";
    PO_AUDIO_STATE.speaking = false;
    PO_AUDIO_STATE.utterance = null;

    if (resetButtons !== false){
      var roots = document.querySelectorAll(ROOT_SEL);
      for (var i=0;i<roots.length;i++) updateAudioButtonsState(roots[i], getLang());
    }
  }

  function cleanAudioText(s){
    return clampStr(s)
      .replace(/\s+/g, " ")
      .replace(/[•·]+/g, ". ")
      .replace(/\s([;:!?])/g, "$1")
      .trim();
  }

  function collectTextFromNode(node){
    if (!node) return "";
    var clone = node.cloneNode(true);
    try{
      var kill = clone.querySelectorAll(".po-axis-audio-wrap, .po-axis-audio-btn, script, style, [aria-hidden='true']");
      for (var i=0;i<kill.length;i++) if (kill[i] && kill[i].parentNode) kill[i].parentNode.removeChild(kill[i]);
    }catch(e){}
    return cleanAudioText(clone.textContent || "");
  }

  function buildGeneralText(root){
    var parts = [];
    var slots = ["title", "kicker", "h_def", "def_short", "def_long"];
    for (var i=0;i<slots.length;i++){
      var el = root.querySelector("[data-po-slot='" + slots[i] + "']");
      var txt = collectTextFromNode(el);
      if (txt) parts.push(txt);
    }
    return cleanAudioText(parts.join(". "));
  }

  function buildDetailText(detail){
    if (!detail) return "";
    var parts = [];
    var title = detail.querySelector(".po-lex-summary__title");
    var titleTxt = collectTextFromNode(title);
    if (titleTxt) parts.push(titleTxt);

    var bodyClone = detail.cloneNode(true);
    try{
      var summary = bodyClone.querySelector("summary");
      if (summary && summary.parentNode) summary.parentNode.removeChild(summary);
      var kill = bodyClone.querySelectorAll(".po-axis-audio-wrap, .po-axis-audio-btn, script, style");
      for (var i=0;i<kill.length;i++) if (kill[i] && kill[i].parentNode) kill[i].parentNode.removeChild(kill[i]);
    }catch(e){}
    var bodyTxt = cleanAudioText(bodyClone.textContent || "");
    if (bodyTxt) parts.push(bodyTxt);
    return cleanAudioText(parts.join(". "));
  }

  function splitTextForSpeech(text, limit){
    var maxLen = limit || 210;
    var src = cleanAudioText(text);
    if (!src) return [];

    var raw = src.match(/[^.!?…]+[.!?…]?/g) || [src];
    var out = [];
    var current = "";

    for (var i=0;i<raw.length;i++){
      var sentence = cleanAudioText(raw[i]);
      if (!sentence) continue;

      if (sentence.length > maxLen){
        var words = sentence.split(/\s+/);
        var acc = "";
        for (var j=0;j<words.length;j++){
          var next = acc ? (acc + " " + words[j]) : words[j];
          if (next.length > maxLen && acc){
            out.push(acc);
            acc = words[j];
          }else acc = next;
        }
        if (acc) out.push(acc);
        continue;
      }

      var candidate = current ? (current + " " + sentence) : sentence;
      if (candidate.length > maxLen && current){
        out.push(current);
        current = sentence;
      }else current = candidate;
    }

    if (current) out.push(current);
    return out;
  }

  function pickSpeechVoice(lang){
    if (!PO_AUDIO_SYNTH || typeof PO_AUDIO_SYNTH.getVoices !== "function") return null;
    var voices = PO_AUDIO_SYNTH.getVoices() || [];
    if (!voices.length) return null;
    var code = normLang(lang || getLang());
    var prefixes = code === "fr" ? ["fr", "fr-"] : (code === "es" ? ["es", "es-"] : ["en", "en-"]);
    for (var i=0;i<voices.length;i++){
      var vLang = clampStr(voices[i].lang).toLowerCase();
      if (!vLang) continue;
      for (var j=0;j<prefixes.length;j++) if (vLang === prefixes[j] || vLang.indexOf(prefixes[j]) === 0) return voices[i];
    }
    return voices[0] || null;
  }

  function buildAudioUnits(root, startKey){
    var units = [];
    if (!root) return units;
    var details = root.querySelectorAll(".po-lex-details");
    var startAt = 0;
    var useGeneral = (startKey === "general");

    if (useGeneral){
      var generalTxt = buildGeneralText(root);
      if (generalTxt) units.push({ key:"general", kind:"general", text:generalTxt, detail:null });
      startAt = 0;
    }else{
      var parsed = parseInt(String(startKey || "").replace(/^block-/, ""), 10);
      startAt = isNaN(parsed) ? 0 : parsed;
    }

    for (var i=startAt;i<details.length;i++){
      var txt = buildDetailText(details[i]);
      if (txt) units.push({ key:"block-" + i, kind:"block", text:txt, detail:details[i] });
    }
    return units;
  }

  function openDetailIfNeeded(unit){
    if (!unit || unit.kind !== "block" || !unit.detail) return;
    try{ unit.detail.open = true; }catch(e){}
  }

  function speakNextChunk(){
    if (!PO_AUDIO_SYNTH || !PO_AUDIO_STATE.speaking) return;

    PO_AUDIO_STATE.chunkPos += 1;
    if (PO_AUDIO_STATE.chunkPos >= PO_AUDIO_STATE.chunks.length){
      PO_AUDIO_STATE.unitPos += 1;
      if (PO_AUDIO_STATE.unitPos >= PO_AUDIO_STATE.units.length){
        stopAudio(true);
        return;
      }

      var unit = PO_AUDIO_STATE.units[PO_AUDIO_STATE.unitPos];
      PO_AUDIO_STATE.activeKey = unit.key;
      PO_AUDIO_STATE.chunks = splitTextForSpeech(unit.text, 210);
      PO_AUDIO_STATE.chunkPos = -1;
      openDetailIfNeeded(unit);
      if (PO_AUDIO_STATE.root) updateAudioButtonsState(PO_AUDIO_STATE.root, getLang());
      if (!PO_AUDIO_STATE.chunks.length){
        speakNextChunk();
        return;
      }
      speakNextChunk();
      return;
    }

    var chunk = clampStr(PO_AUDIO_STATE.chunks[PO_AUDIO_STATE.chunkPos]);
    if (!chunk){
      speakNextChunk();
      return;
    }

    var utt;
    try{
      utt = new SpeechSynthesisUtterance(chunk);
    }catch(e){
      stopAudio(true);
      return;
    }

    var lang = getLang();
    utt.lang = lang === "fr" ? "fr-FR" : (lang === "es" ? "es-ES" : "en-US");
    var voice = pickSpeechVoice(lang);
    if (voice) utt.voice = voice;
    utt.rate = 0.96;
    utt.pitch = 1;
    utt.volume = 1;

    utt.onend = function(){
      PO_AUDIO_STATE.utterance = null;
      speakNextChunk();
    };
    utt.onerror = function(){
      PO_AUDIO_STATE.utterance = null;
      speakNextChunk();
    };

    PO_AUDIO_STATE.utterance = utt;
    try{
      PO_AUDIO_SYNTH.speak(utt);
    }catch(e){
      stopAudio(true);
    }
  }

  function startAudio(root, startKey){
    if (!PO_AUDIO_SYNTH || !root) return;

    var sameRoot = (PO_AUDIO_STATE.root === root);
    var sameKey = (PO_AUDIO_STATE.activeKey === startKey);
    if (sameRoot && sameKey && (PO_AUDIO_SYNTH && (PO_AUDIO_SYNTH.speaking || PO_AUDIO_SYNTH.pending))){
      stopAudio(true);
      return;
    }

    stopAudio(false);

    PO_AUDIO_STATE.root = root;
    PO_AUDIO_STATE.units = buildAudioUnits(root, startKey);
    PO_AUDIO_STATE.unitPos = -1;
    PO_AUDIO_STATE.chunks = [];
    PO_AUDIO_STATE.chunkPos = -1;
    PO_AUDIO_STATE.activeKey = startKey;
    PO_AUDIO_STATE.speaking = true;

    updateAudioButtonsState(root, getLang());
    speakNextChunk();
  }

  function bindAudioButton(btn, root){
    if (!btn || !root || btn.__poAudioBound) return;
    btn.addEventListener("click", function(ev){
      if (ev && typeof ev.preventDefault === "function") ev.preventDefault();
      if (ev && typeof ev.stopPropagation === "function") ev.stopPropagation();
      if (!PO_AUDIO_SYNTH) return;
      var role = clampStr(btn.getAttribute("data-po-audio-role") || "block");
      var idx = clampStr(btn.getAttribute("data-po-audio-index") || "");
      var key = (role === "general") ? "general" : ("block-" + idx);
      startAudio(root, key);
    });
    btn.__poAudioBound = true;
  }

  function ensureAudioButtons(root, lang){
    if (!root) return;
    ensureAudioStyles();

    var panel = root.querySelector(".po-lex-panel");
    if (!panel) return;

    var generalWrap = root.querySelector(".po-axis-audio-wrap[data-po-audio-role='general']");
    if (!generalWrap){
      generalWrap = document.createElement("div");
      generalWrap.className = "po-axis-audio-wrap";
      generalWrap.setAttribute("data-po-audio-role", "general");

      var generalBtn = createAudioButton("general");
      generalWrap.appendChild(generalBtn);

      var meta = root.querySelector(".po-axis-meta");
      var defShort = root.querySelector("[data-po-slot='def_short']");
      var firstDetail = panel.querySelector(".po-lex-details");

      if (meta && meta.parentNode){
        if (meta.nextSibling) meta.parentNode.insertBefore(generalWrap, meta.nextSibling);
        else meta.parentNode.appendChild(generalWrap);
      } else if (defShort && defShort.parentNode){
        defShort.parentNode.insertBefore(generalWrap, defShort);
      } else if (firstDetail && firstDetail.parentNode){
        firstDetail.parentNode.insertBefore(generalWrap, firstDetail);
      } else {
        panel.appendChild(generalWrap);
      }
    }

    var generalButton = generalWrap.querySelector(".po-axis-audio-btn[data-po-audio-role='general']");
    if (!generalButton){
      generalButton = createAudioButton("general");
      generalWrap.appendChild(generalButton);
    }
    bindAudioButton(generalButton, root);

    var details = root.querySelectorAll(".po-lex-details");
    for (var i=0;i<details.length;i++){
      details[i].setAttribute("data-po-audio-index", String(i));
      var summary = details[i].querySelector(".po-lex-summary");
      if (!summary) continue;

      var btn = summary.querySelector(".po-axis-audio-btn[data-po-audio-role='block']");
      if (!btn){
        btn = createAudioButton("block", i);
        summary.appendChild(btn);
      }else btn.setAttribute("data-po-audio-index", String(i));

      bindAudioButton(btn, root);
    }

    updateAudioButtonsState(root, lang || getLang());
  }

  function initAudioEverywhere(lang){
    var l = normLang(lang || getLang());
    var roots = document.querySelectorAll(ROOT_SEL);
    for (var i=0;i<roots.length;i++) ensureAudioButtons(roots[i], l);
  }

  try{
    if (PO_AUDIO_SYNTH && typeof PO_AUDIO_SYNTH.getVoices === "function"){
      PO_AUDIO_SYNTH.onvoiceschanged = function(){
        try{ initAudioEverywhere(getLang()); }catch(e){}
      };
    }
  }catch(e){}

  /* --------------------------------------------------------------------------
   * TEXTES TRI (Tiqqunbahu)
   * -------------------------------------------------------------------------- */

  var IMG_IDEOGRAM_CONCEPT = "https://cdn.shopify.com/s/files/1/0851/1242/2733/files/Tiqqunbahu_copie_2.png?v=1772886448";
  var IMG_ELEMENT = "https://cdn.shopify.com/s/files/1/0851/1242/2733/files/Katuvys_copie.png?v=1750254535";
  var IMG_TOTEM = "https://cdn.shopify.com/s/files/1/0851/1242/2733/files/Ekho.png?v=1773404195";
  var IMG_FREQ_130 = "https://cdn.shopify.com/s/files/1/0851/1242/2733/files/Nombre_guide_130.png?v=1773410721";

  var FALLBACK = {
    fr: {
      title: CANON.title,
      kicker:
        "Extrait du <em>Katûpirsia&nbsp;5 - La Matrice-substrat</em><br />(Katûsýs : organe interne de la Katûvýs)",
      h_def: "Définition opérative",
      chips: ["Élément", "Totem", "Fréquence"],
      def_short:
        "Fractales de convergence ; configurations de réintégration dynamique opérant dans l’interstice des syntonies du champ katûvýsique.",
      def_long:
        "Tiqqunbahu accueille et articule des syntonies selon un agencement magnétique souple, fondé sur résonance, tension et relâchement. Il amplifie les motifs rythmiques, soutient une stabilisation temporaire des instabilités, et instaure des seuils adaptatifs qui filtrent, orientent et redistribuent la circulation des flux entre éléments internes et émanations.\n\n" +
        "Dans l’architecture posœnnoïale de La Katûvýs, Tiqqunbahu désigne un élément interne fondamental : les fractales de convergence, forme spécifique de structuration spiralée opérant dans l’interstice des syntonies vibratoires du champ katûvýsique. Tiqqunbahu agit à l’endroit précis où les lignes d’intensité se croisent, où les fréquences entrent en contact, où la circulation demande une intelligence d’agencement, de retenue et de relance.\n\n" +
        "Il se présente comme des configurations de réintégration dynamique où plusieurs syntonies, parfois divergentes ou hétérogènes, se rencontrent et se répondent selon une logique d’addition active. Cette articulation produit une harmonie émergente, transitoire, où chaque syntonie maintient son intégrité tout en contribuant à une structure d’ensemble, en régime de co-présence synchrêtique.",
      h_features: "Fonctions",
      h_questions: "Tests d’usage",
      hint_fold: "déplier",
      hint_fold2: "déplier",
      hint_fold3: "déplier",
      example_title: "Ex.",
      example:
        "Quand plusieurs syntonies se rencontrent et “tiennent ensemble” en cohérence provisoire : « Tiqqunbahu travaille ». Pour installer une répétition féconde en micro-rythmes et variants : « j’active Tiqqunbahu ». Quand un passage demande filtrage, orientation, redistribution : « Tiqqunbahu règle le seuil ». ",
      features: [
        "Statut : fractales de convergence ; matrice d’intégration.",
        "Fonction principale : intégration modulante des syntonies, amplification rythmique, stabilisation temporaire.",
        "Seuils adaptatifs : filtrer / orienter / redistribuer les flux et les résonances selon l’état du champ.",
        "Ponts vibratoires et matrices de translation lors d’activations de Katûvýsqun ou dans le déploiement de Balakallpa.",
        "Le multiple s’ordonne en gardant sa charge propre ; la convergence s’entend comme retissage."
      ],
      questions: [
        "Quand plusieurs syntonies se rencontrent et tiennent ensemble en cohérence provisoire, est-ce Tiqqunbahu qui travaille ?",
        "Le passage demande-t-il filtrage, orientation ou redistribution ?",
        "Quels micro-motifs reviennent avec insistance et demandent d’être convertis en structure intégrative ?",
        "Quelle cohérence temporaire peut rendre le champ habitable sans réduire la pluralité ?"
      ],
      h_family: "Relations systémiques",
      family_1:
        "<p><strong>Position systémique :</strong> Tiqqunbahu appartient à <strong>Katûsýs</strong>, bande interne d’où s’expriment les unités actives de la <strong>Katûvýs</strong>. Il agit comme zone d’intégration modulante où le multiple s’ordonne en gardant sa charge propre, et où la convergence s’entend comme retissage.</p>",
      family_2:
        "<p><strong>Relations prioritaires :</strong> interaction étroite avec <strong>Taxiêlîs</strong> (nœuds de syntonie), <strong>Takimarah</strong> (modulateurs d’interface), <strong>Lulæṣírasen</strong> (matrice des vortex), et rôle de circulation filtrée entre organes internes de <strong>Katûsýs</strong> et émanations de <strong>Balakallpa</strong>.</p>",
      h_wordbuild: "Construction du concept (Tiqqun + Bahu) et fréquence 130",
      word_blocks: [
        {
          head: "1) Tiqqun — réparation / rectification / réorganisation",
          text:
            "Tiqqun porte la logique de réparation active, de rectification et de réagencement. Dans Tiqqunbahu, cette charge devient puissance de retissage et de recomposition opérative."
        },
        {
          head: "2) Bahu — multiplicité abondante",
          text:
            "Bahu porte la multiplicité étendue, l’abondance et l’expansion du multiple. Dans Tiqqunbahu, cette multiplicité reste ouverte, ramifiable et articulable sans réduction uniformisante."
        },
        {
          head: "3) Fréquence 130 — lecture opérative",
          text:
            "T(20) + I(9) + Q(17) + Q(17) + U(21) + N(14) + B(2) + A(1) + H(8) + U(21) = 130.\n\n1 + 3 + 0 = 4 : assise, stabilité opérative, tenue structurante.\n13 + 0 = 13 : réorganisation transmutative, passage intensif, reconfiguration profonde.\n130 = 13 × 10 : transmutation récurrente, reprise structurée, retissage périodique où la convergence se réactive et se redistribue."
        }
      ],
      word_notes: [
        "Élément : La Katûvýs ; Totem : Êkhö ; Fréquence (nombre-guide) : 130.",
        "Mode d’activation : multiplication de micro-motifs — répétitions discrètes, retours insistants d’un rythme, d’une image, d’un nœud de sens — convertis en structure intégrative.",
        "Fonctions rituelles : réintégration de syntonies dispersées ; stabilisation temporaire d’instabilités excédentaires ; circulation filtrée ; translation rituelle.",
        "Phrase opérative : « Tiqqunbahu : je retisse le multiple, j’accueille la tension, et la convergence devient tenue, habitabilité, relance. »"
      ],
      cta_translate: "Proposer une traduction du concept"
    },

    en: {
      title: CANON.title,
      kicker:
        "Excerpt from <em>Katûpirsia&nbsp;5 - La Matrice-substrat</em><br />(Katûsýs: internal organ of Katûvýs)",
      h_def: "Operative definition",
      chips: ["Element", "Totem", "Frequency"],
      def_short:
        "Convergence fractals; dynamic reintegration configurations operating in the interstice of the syntonies of the champ de la Katûvýs.",
      def_long:
        "Tiqqunbahu welcomes and articulates syntonies through a supple magnetic arrangement grounded in resonance, tension and release. It amplifies rhythmic motifs, supports a temporary stabilization of instabilities, and institutes adaptive thresholds that filter, orient and redistribute the circulation of flows between internal elements and emanations.\n\n" +
        "Within the posœnnoïal architecture of Katûvýs, Tiqqunbahu names a fundamental internal element: convergence fractals, a specific spiral structuring operating in the interstice of the field’s vibratory syntonies. It acts where intensity lines cross, where frequencies come into contact, and where circulation requires an intelligence of arranging, holding and relaunching.\n\n" +
        "It appears as configurations of dynamic reintegration in which several syntonies, sometimes divergent or heterogeneous, meet and respond to one another through active addition. This articulation produces an emergent, transitory harmony in which each syntony keeps its integrity while contributing to an overall structure, in a regime of co-présence synchrêtique.",
      h_features: "Functions",
      h_questions: "Usage tests",
      hint_fold: "expand",
      hint_fold2: "expand",
      hint_fold3: "expand",
      example_title: "Ex.",
      example:
        "When several syntonies meet and ‘hold together’ in provisional coherence: ‘Tiqqunbahu is working’. To install a fertile repetition in micro-rhythms and variants: ‘I activate Tiqqunbahu’. When a passage requires filtering, orientation, redistribution: ‘Tiqqunbahu regulates the threshold’. ",
      features: [
        "Status: convergence fractals; integration matrix.",
        "Main function: modulatory integration of syntonies, rhythmic amplification, temporary stabilization.",
        "Adaptive thresholds: filter / orient / redistribute flows and resonances according to the state of the field.",
        "Vibratory bridges and translation matrices in activations of Katûvýsqun or in the deployment of Balakallpa.",
        "The multiple is organized while keeping its own charge; convergence is understood as reweaving."
      ],
      questions: [
        "When several syntonies meet and hold together in provisional coherence, is Tiqqunbahu at work?",
        "Does the passage require filtering, orientation or redistribution?",
        "Which micro-motifs return insistently and need to be converted into an integrative structure?",
        "Which temporary coherence can make the field inhabitable without reducing plurality?"
      ],
      h_family: "Systemic relations",
      family_1:
        "<p><strong>Systemic position:</strong> Tiqqunbahu belongs to <strong>Katûsýs</strong>, the internal band where the active units of <strong>Katûvýs</strong> are expressed. It acts as a modulatory integration zone where the multiple is organized while keeping its own charge, and where convergence is understood as reweaving.</p>",
      family_2:
        "<p><strong>Priority relations:</strong> close interaction with <strong>Taxiêlîs</strong> (syntony nodes), <strong>Takimarah</strong> (interface modulators), <strong>Lulæṣírasen</strong> (matrix of vortices), and a role of filtered circulation between internal organs of <strong>Katûsýs</strong> and emanations of <strong>Balakallpa</strong>.</p>",
      h_wordbuild: "Concept construction (Tiqqun + Bahu) and frequency 130",
      word_blocks: [
        {
          head: "1) Tiqqun — repair / rectification / reorganization",
          text:
            "Tiqqun carries the logic of active repair, rectification and rearrangement. In Tiqqunbahu, this charge becomes a power of reweaving and operative recomposition."
        },
        {
          head: "2) Bahu — abundant multiplicity",
          text:
            "Bahu carries extended multiplicity, abundance and the expansion of the multiple. In Tiqqunbahu, this multiplicity remains open, branching and articulable without uniform reduction."
        },
        {
          head: "3) Frequency 130 — operative reading",
          text:
            "T(20) + I(9) + Q(17) + Q(17) + U(21) + N(14) + B(2) + A(1) + H(8) + U(21) = 130.\n\n1 + 3 + 0 = 4: base, operative stability, structuring hold.\n13 + 0 = 13: transmutative reorganization, intensive passage, deep reconfiguration.\n130 = 13 × 10: recurrent transmutation, structured reprise, periodic reweaving where convergence is reactivated and redistributed."
        }
      ],
      word_notes: [
        "Element: Katûvýs; Totem: Êkhö; Frequency (nombre-guide): 130.",
        "Activation mode: multiplication of micro-motifs — discreet repetitions, insistent returns of a rhythm, an image, a knot of meaning — converted into an integrative structure.",
        "Ritual functions: reintegration of dispersed syntonies; temporary stabilization of excess instabilities; filtered circulation; ritual translation.",
        "Operative phrase: ‘Tiqqunbahu: I reweave the multiple, I welcome tension, and convergence becomes holding, inhabitable, relaunch.’"
      ],
      cta_translate: "Suggest a translation of the concept"
    },

    es: {
      title: CANON.title,
      kicker:
        "Extracto de <em>Katûpirsia&nbsp;5 - La Matrice-substrat</em><br />(Katûsýs: órgano interno de la Katûvýs)",
      h_def: "Definición operativa",
      chips: ["Elemento", "Tótem", "Frecuencia"],
      def_short:
        "Fractales de convergencia; configuraciones de reintegración dinámica que operan en el intersticio de las sintonías del champ de la Katûvýs.",
      def_long:
        "Tiqqunbahu acoge y articula sintonías según un agenciamiento magnético flexible, fundado en resonancia, tensión y relajación. Amplifica motivos rítmicos, sostiene una estabilización temporal de las inestabilidades e instaura umbrales adaptativos que filtran, orientan y redistribuyen la circulación de los flujos entre elementos internos y emanaciones.\n\n" +
        "En la arquitectura posœnnoïal de la Katûvýs, Tiqqunbahu nombra un elemento interno fundamental: fractales de convergencia, una forma específica de estructuración espiral que opera en el intersticio de las sintonías vibratorias del campo. Actúa en el punto preciso donde se cruzan las líneas de intensidad, donde las frecuencias entran en contacto y donde la circulación exige una inteligencia de agenciamiento, contención y relance.\n\n" +
        "Aparece como configuraciones de reintegración dinámica en las que varias sintonías, a veces divergentes o heterogéneas, se encuentran y se responden según una lógica de adición activa. Esta articulación produce una armonía emergente y transitoria en la que cada sintonía mantiene su integridad y a la vez contribuye a una estructura de conjunto, en régimen de copresencia sincrética.",
      h_features: "Funciones",
      h_questions: "Pruebas de uso",
      hint_fold: "desplegar",
      hint_fold2: "desplegar",
      hint_fold3: "desplegar",
      example_title: "Ej.",
      example:
        "Cuando varias sintonías se encuentran y ‘se mantienen juntas’ en una coherencia provisoria: ‘Tiqqunbahu trabaja’. Para instalar una repetición fértil en micro-ritmos y variantes: ‘activo Tiqqunbahu’. Cuando un pasaje exige filtrado, orientación y redistribución: ‘Tiqqunbahu regula el umbral’. ",
      features: [
        "Estatus: fractales de convergencia; matriz de integración.",
        "Función principal: integración modulante de sintonías, amplificación rítmica, estabilización temporal.",
        "Umbrales adaptativos: filtrar / orientar / redistribuir flujos y resonancias según el estado del campo.",
        "Puentes vibratorios y matrices de traslación en activaciones de Katûvýsqun o en el despliegue de Balakallpa.",
        "Lo múltiple se organiza conservando su propia carga; la convergencia se entiende como retejido."
      ],
      questions: [
        "Cuando varias sintonías se encuentran y se sostienen juntas en una coherencia provisoria, ¿trabaja Tiqqunbahu?",
        "¿El pasaje requiere filtrado, orientación o redistribución?",
        "¿Qué micro-motivos regresan con insistencia y deben convertirse en una estructura integradora?",
        "¿Qué coherencia temporal puede volver habitable el campo sin reducir la pluralidad?"
      ],
      h_family: "Relaciones sistémicas",
      family_1:
        "<p><strong>Posición sistémica:</strong> Tiqqunbahu pertenece a <strong>Katûsýs</strong>, banda interna donde se expresan las unidades activas de la <strong>Katûvýs</strong>. Actúa como una zona de integración modulante donde lo múltiple se ordena conservando su propia carga, y donde la convergencia se entiende como retejido.</p>",
      family_2:
        "<p><strong>Relaciones prioritarias:</strong> interacción estrecha con <strong>Taxiêlîs</strong> (nodos de sintonía), <strong>Takimarah</strong> (moduladores de interfaz), <strong>Lulæṣírasen</strong> (matriz de vórtices), y un papel de circulación filtrada entre órganos internos de <strong>Katûsýs</strong> y emanaciones de <strong>Balakallpa</strong>.</p>",
      h_wordbuild: "Construcción del concepto (Tiqqun + Bahu) y frecuencia 130",
      word_blocks: [
        {
          head: "1) Tiqqun — reparación / rectificación / reorganización",
          text:
            "Tiqqun porta la lógica de la reparación activa, la rectificación y el reordenamiento. En Tiqqunbahu, esta carga se vuelve potencia de retejido y recomposición operativa."
        },
        {
          head: "2) Bahu — multiplicidad abundante",
          text:
            "Bahu porta la multiplicidad extendida, la abundancia y la expansión de lo múltiple. En Tiqqunbahu, esta multiplicidad permanece abierta, ramificable y articulable sin reducción uniformizante."
        },
        {
          head: "3) Frecuencia 130 — lectura operativa",
          text:
            "T(20) + I(9) + Q(17) + Q(17) + U(21) + N(14) + B(2) + A(1) + H(8) + U(21) = 130.\n\n1 + 3 + 0 = 4: base, estabilidad operativa, sostén estructurante.\n13 + 0 = 13: reorganización transmutativa, pasaje intensivo, reconfiguración profunda.\n130 = 13 × 10: transmutación recurrente, reprise estructurada, retejido periódico donde la convergencia se reactiva y se redistribuye."
        }
      ],
      word_notes: [
        "Elemento: La Katûvýs; Tótem: Êkhö; Frecuencia (nombre-guide): 130.",
        "Modo de activación: multiplicación de micro-motivos — repeticiones discretas, retornos insistentes de un ritmo, una imagen, un nudo de sentido — convertidos en estructura integradora.",
        "Funciones rituales: reintegración de sintonías dispersas; estabilización temporal de inestabilidades excedentes; circulación filtrada; traslación ritual.",
        "Frase operativa: ‘Tiqqunbahu: retejo lo múltiple, acojo la tensión, y la convergencia se vuelve sostén, habitabilidad y relance.’"
      ],
      cta_translate: "Proponer una traducción del concepto"
    }
  };

  /* --------------------------------------------------------------------------
   * Slots helpers
   * -------------------------------------------------------------------------- */

  function setPressed(root, lang){
    if (!root) return;
    var btns = root.querySelectorAll("[data-po-langbar] [data-po-lang]");
    for (var i=0;i<btns.length;i++){
      var b = btns[i];
      var l = normLang(b.getAttribute("data-po-lang") || "");
      b.setAttribute("aria-pressed", (l === lang) ? "true" : "false");
    }
  }

  function setSlotText(root, slot, txt){
    var el = root.querySelector("[data-po-slot='" + slot + "']");
    if (!el) return;
    el.textContent = normalizeCanonicalFrench(clampStr(txt));
  }

  function setSlotHTML(root, slot, html){
    var el = root.querySelector("[data-po-slot='" + slot + "']");
    if (!el) return;
    el.innerHTML = protectKeywordsHTML(normalizeCanonicalFrench(clampStr(html)));
    protectKeywordsInElement(el);
  }

  function setSlotImg(root, slot, src, alt){
    var el = root.querySelector("[data-po-slot='" + slot + "']");
    if (!el) return;

    var s = clampStr(src);
    var a = clampStr(alt);

    if (!s){
      try{ el.removeAttribute("src"); }catch(e){}
      try{ el.setAttribute("alt", ""); }catch(e){}
      try{ el.style.display = "none"; }catch(e){}
      return;
    }

    try{ el.setAttribute("src", s); }catch(e){}
    try{ el.setAttribute("alt", a); }catch(e){}
    try{ el.style.display = ""; }catch(e){}
  }

  function renderListInto(root, slot, items){
    var el = root.querySelector("[data-po-slot='" + slot + "']");
    if (!el) return;
    var arr = Array.isArray(items) ? items : [];
    var out = [];
    for (var i=0;i<arr.length;i++){
      out.push("<li>" + protectKeywordsHTML(escapeHTML(normalizeCanonicalFrench(clampStr(arr[i])))) + "</li>");
    }
    el.innerHTML = out.join("");
    protectKeywordsInElement(el);
  }

  function renderWordBlocks(root, slot, blocks){
    var host = root.querySelector("[data-po-slot='" + slot + "']");
    if (!host) return;
    var arr = Array.isArray(blocks) ? blocks : [];
    var out = [];
    for (var i=0;i<arr.length;i++){
      var b = arr[i] || {};
      var h = normalizeCanonicalFrench(clampStr(b.head || ""));
      var t = normalizeCanonicalFrench(clampStr(b.text || ""));
      out.push(
        '<div class="po-axis-wb">' +
          '<div class="po-axis-wb__h">' + protectKeywordsHTML(escapeHTML(h)) + '</div>' +
          '<div class="po-axis-wb__t">' + protectKeywordsHTML(escapeHTML(t)).replace(/\n/g, "<br />") + '</div>' +
        '</div>'
      );
    }
    host.innerHTML = out.join("");
    protectKeywordsInElement(host);
  }

  function setCtaTranslate(root, lang){
    var el = root.querySelector('[data-po-slot="cta_translate"]');
    if (!el) return;
    el.textContent = clampStr((FALLBACK[lang] && FALLBACK[lang].cta_translate) || FALLBACK.fr.cta_translate);
  }

  /* --------------------------------------------------------------------------
   * Lexicon -> page data (terme FR verrouillé si présent)
   * -------------------------------------------------------------------------- */

  function resolveMainEntry(root){
    var id = "";
    try{ id = root.getAttribute("data-po-lex-id") || ""; }catch(e){ id = ""; }
    return (
      getLexiconEntry(id) ||
      getLexiconEntry("tiqqunbahu") ||
      getLexiconEntry("Tiqqunbahu") ||
      null
    );
  }

  function chooseFallback(lang){
    var l = normLang(lang);
    return FALLBACK[l] || FALLBACK.fr;
  }

  function firstNonEmpty(){
    for (var i=0;i<arguments.length;i++){
      var v = arguments[i];
      if (Array.isArray(v)){
        if (v.length) return v;
      }else if (clampStr(v)) return v;
    }
    return Array.isArray(arguments[0]) ? [] : "";
  }

  function renderAxis(root, lang){
    var L = chooseFallback(lang);
    var eMain = resolveMainEntry(root);

    var titleFR = firstNonEmpty(pickTerm(eMain, "fr"), CANON.title);
    setSlotText(root, "title", titleFR);
    setSlotImg(root, "title_img", IMG_IDEOGRAM_CONCEPT, titleFR);

    var kicker = firstNonEmpty(
      pickAny(eMain, "kicker_" + lang, ""),
      pickAny(eMain, "kicker_fr", ""),
      pickAny(eMain, "kicker", ""),
      L.kicker
    );
    setSlotHTML(root, "kicker", kicker);

    setSlotText(root, "h_def", firstNonEmpty(pickAny(eMain, "h_def_" + lang, ""), L.h_def));
    setSlotText(root, "chip_1", (L.chips && L.chips[0]) || "");
    setSlotText(root, "chip_2", (L.chips && L.chips[1]) || "");
    setSlotText(root, "chip_3", (L.chips && L.chips[2]) || "");

    setSlotImg(root, "chip_1_img", IMG_ELEMENT, (L.chips && L.chips[0]) || "Élément");
    setSlotImg(root, "chip_2_img", IMG_TOTEM, (L.chips && L.chips[1]) || "Totem");
    setSlotImg(root, "chip_3_img", IMG_FREQ_130, (L.chips && L.chips[2]) || "Fréquence");

    var defShort = firstNonEmpty(pickDefShort(eMain, lang), pickDefShort(eMain, "fr"), L.def_short);
    var defLong  = firstNonEmpty(pickDefLong(eMain, lang), pickDefLong(eMain, "fr"), L.def_long);
    setSlotHTML(root, "def_short", htmlParagraphize(defShort));
    setSlotHTML(root, "def_long", htmlParagraphize(defLong));

    setSlotText(root, "h_features", firstNonEmpty(pickAny(eMain, "h_features_" + lang, ""), L.h_features));
    setSlotText(root, "hint_fold", firstNonEmpty(pickAny(eMain, "hint_fold_" + lang, ""), L.hint_fold));
    renderListInto(root, "features", firstNonEmpty(pickArray(eMain, lang, "features"), pickArray(eMain, "fr", "features"), L.features || []));

    setSlotText(root, "h_questions", firstNonEmpty(pickAny(eMain, "h_questions_" + lang, ""), L.h_questions));
    setSlotText(root, "hint_fold2", firstNonEmpty(pickAny(eMain, "hint_fold2_" + lang, ""), L.hint_fold2));
    renderListInto(root, "questions", firstNonEmpty(pickArray(eMain, lang, "questions"), pickArray(eMain, "fr", "questions"), L.questions || []));
    setSlotHTML(
      root,
      "example_box",
      '<div><strong>' + protectKeywordsHTML(escapeHTML(L.example_title || "Ex.")) + '</strong> ' +
      protectKeywordsHTML(escapeHTML(L.example || "")) + '</div>'
    );

    setSlotText(root, "h_family", firstNonEmpty(pickAny(eMain, "h_family_" + lang, ""), L.h_family));
    setSlotText(root, "hint_fold3", firstNonEmpty(pickAny(eMain, "hint_fold3_" + lang, ""), L.hint_fold3));
    setSlotHTML(root, "family_1", firstNonEmpty(pickAny(eMain, "family_1_" + lang, ""), pickAny(eMain, "family_1_fr", ""), L.family_1));
    setSlotHTML(root, "family_2", firstNonEmpty(pickAny(eMain, "family_2_" + lang, ""), pickAny(eMain, "family_2_fr", ""), L.family_2));

    setSlotText(root, "h_wordbuild", firstNonEmpty(pickAny(eMain, "h_wordbuild_" + lang, ""), L.h_wordbuild));
    renderWordBlocks(root, "wordbuild_blocks", firstNonEmpty(pickArray(eMain, lang, "word_blocks"), pickArray(eMain, "fr", "word_blocks"), L.word_blocks || []));
    renderListInto(root, "wordbuild_notes", firstNonEmpty(pickArray(eMain, lang, "word_notes"), pickArray(eMain, "fr", "word_notes"), L.word_notes || []));

    setCtaTranslate(root, lang);
    setPressed(root, lang);
  }

  /* --------------------------------------------------------------------------
   * Render orchestration
   * -------------------------------------------------------------------------- */

  function applyLangEverywhere(lang){
    var l = normLang(lang || getLang());
    storeLang(l);

    var roots = document.querySelectorAll(ROOT_SEL);
    for (var i=0;i<roots.length;i++) renderAxis(roots[i], l);

    initAudioEverywhere(l);
    notifyLocaleChanged();
    return l;
  }

  function init(){
    applyLangEverywhere(getLang());
  }

  function setLang(lang){
    return applyLangEverywhere(lang);
  }

  window.addEventListener("po:lexicon-ready", function(){
    try{ applyLangEverywhere(getLang()); }catch(e){}
  });

  window.PoKatupirsia5TiqqunbahuTextsFR_EN_ES_20260303 = {
    getLang: getLang,
    setLang: setLang,
    init: init,
    stopAudio: stopAudio,
    normLang: normLang
  };

  if (document.readyState === "loading"){
    document.addEventListener("DOMContentLoaded", init);
  }else{
    init();
  }

})();
